import React from 'react';
import DateFormat from '../../../commons/componentes/DateFormat';
import MoneyFormatter from '../../../commons/componentes/MoneyFormatter';
import type { ServicioHistoricoEntry } from './servicio-asignado-form';

export default function ServicioAsignadoHistoricoPanel({
  entries,
  inactivo = false,
  footer,
}: {
  entries: ServicioHistoricoEntry[];
  inactivo?: boolean;
  footer?: React.ReactNode;
}) {
  const textColor = inactivo ? '#94a3b8' : '#0f172a';
  const mutedColor = inactivo ? '#94a3b8' : undefined;

  return (
    <div
      style={{
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        padding: '14px 16px',
        background: inactivo ? '#f1f5f9' : '#f8fafc',
        height: '100%',
        minHeight: 280,
        display: 'flex',
        flexDirection: 'column',
        color: textColor,
      }}
    >
      <h3
        className="m-0 mb-3"
        style={{ fontSize: 14, fontWeight: 700, color: textColor, lineHeight: 1.3 }}
      >
        Histórico
      </h3>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          maxHeight: 240,
          overflowY: 'auto',
          overflowX: 'auto',
          color: mutedColor,
          border: entries.length > 0 ? '1px solid #e2e8f0' : undefined,
          borderRadius: entries.length > 0 ? 8 : undefined,
          background: entries.length > 0 ? '#fff' : undefined,
        }}
      >
        {entries.length === 0 ? (
          <p className="m-0" style={{ fontSize: 13, color: mutedColor ?? '#64748b' }}>
            Sin registros históricos.
          </p>
        ) : (
          <table className="table tabla-chica mb-0" style={{ minWidth: 200, color: mutedColor }}>
            <thead>
              <tr className="bg-primary">
                <th
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  Fecha
                </th>
                <th
                  className="text-end"
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  Precio
                </th>
              </tr>
            </thead>
            <tbody>
              {entries.map((row, index) => (
                <tr key={`${row.fecha}-${row.precio}-${index}`}>
                  <td>
                    <DateFormat value={row.fecha} />
                  </td>
                  <td className="text-end">
                    <MoneyFormatter value={row.precio} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {footer ? <div style={{ marginTop: 12, flexShrink: 0 }}>{footer}</div> : null}
    </div>
  );
}
